import type { ReactNode } from 'react'
import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
  theme: 'light' | 'dark'
  toggleTheme: () => void
}

function Layout({ children, theme, toggleTheme }: LayoutProps) {
  return (
    <div id="page-top" className="ac-shell">
      <Header theme={theme} toggleTheme={toggleTheme} />
      <main id="main-content" tabIndex={-1}>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
